import React from 'react';
import { ClipboardItem } from '../../../../utils/fingeringClipboard';
import { STRING_DIGITS, noteColor } from '../../../../types/fingeringEditor';

interface PlacementGhostProps {
  items: ClipboardItem[];
  pos: { x: number; y: number } | null;
}

const GHOST_R = 4.8;

/**
 * 配置モード中のゴースト（コピー塊の半透明プレビュー）。SVG 子要素として描画。
 * pointer-events は無効（入力捕捉は PlacementCaptureOverlay が担う）。
 */
const PlacementGhost: React.FC<PlacementGhostProps> = ({ items, pos }) => {
  if (!pos) return null;
  return (
    <g data-testid="placement-ghost" pointerEvents="none" opacity={0.55}>
      {items.map((it, i) => {
        const cx = pos.x + it.dx;
        const cy = pos.y + it.dy;
        const color = noteColor(it.string);
        return (
          <g data-testid="placement-ghost-note" key={i}>
            <circle cx={cx} cy={cy} r={GHOST_R} fill="#fff" fillOpacity={0.3}
              stroke={color} strokeWidth={1.2} strokeDasharray="2 1" />
            <text x={cx} y={cy} textAnchor="middle" dominantBaseline="central"
              fontSize={7.2} fontWeight={700} fill={color}
              fontFamily="Helvetica, Arial, sans-serif" style={{ pointerEvents: 'none', userSelect: 'none' }}>
              {it.string != null ? STRING_DIGITS[it.string - 1] : '?'}
            </text>
            <text x={cx} y={cy + GHOST_R + 1.5 + 9.0 * 0.35} textAnchor="middle" dominantBaseline="central"
              fontSize={9.0} fontWeight={700} fill={color}
              fontFamily="Helvetica, Arial, sans-serif" style={{ pointerEvents: 'none', userSelect: 'none' }}>
              {it.fret ?? '?'}
            </text>
          </g>
        );
      })}
    </g>
  );
};

export default PlacementGhost;
